module.exports = __webpack_public_path__ + "img/Learn_English_4.375459d0.jpg";